import { Typography } from "@mui/material";
import { BannerContainer } from "./Banner.styled";
import contact from "assets/images/banners/wavelight.jpg";
import { BookAppointmentButton } from "components";

const Banner = () => {
  return (
    <>
      <BannerContainer
        image={contact}
        px={{ md: 10, xs: 5 }}
        display="flex" 
        justifyContent="center"
        flexDirection="column"
      >
        <Typography
          component="h2"
  fontSize={{ md: "4.125rem", xs: "2.25rem" }}
  fontWeight={600}
  lineHeight={1}
  textTransform={'uppercase'}
  
        >
          Perfect Vision,<br></br>Without Glasses
        </Typography>
        <Typography
            fontSize={{ md: "2.375rem", xs: "1.375rem" }}
            fontWeight="300"
            margin={'15px 0 15px 0'}
          >
            With WaveLight Plus Technology
          </Typography>
        <Typography
            fontSize={{ md: "1.375rem", xs: "1.375rem" }}
            fontWeight="500"
          >
            Experience truly revolutionary, AI-guided laser precision that tailors vision<br></br> correction uniquely to your eyes — safe, bladeless, and fully personalized.

          </Typography>
          <BookAppointmentButton />
      </BannerContainer>
    </>
  );
};

export default Banner;
